/**
 * Tabs
 */

const tabsLinks = document.querySelectorAll('.js-tabs .tabs__nav a');
const tabsNext = document.querySelector('.js-tabs .tabs__controls .tabs__next');
const tabsPrev = document.querySelector('.js-tabs .tabs__controls .tabs__prev');

const handleTabs = () => {
	if (! tabsLinks.length) {
		return;
	}

	tabsNext.addEventListener('click',function(){
		for (let i = tabsLinks.length - 1; i >= 0; i--) {
			if (tabsLinks[i].closest('li').classList.contains('is-active')) {
				const nextLink = tabsLinks[i + 1];

				const oldCurrentTab = document.getElementById(tabsLinks[i].getAttribute('href'));

				const newCurrentTab = document.getElementById(nextLink.getAttribute('href'));

				tabsLinks[i].closest('li').classList.remove('is-active');

				nextLink.closest('li').classList.add('is-active');

				if (newCurrentTab == null) {
					return;
				}
				const tabs = this.closest('.js-tabs');


				tabs.querySelectorAll('.tab').forEach(tab => {
					setTimeout(function () {
						tab.classList.remove('is-active');
					}, 200)
				});

				setTimeout(function () {
					newCurrentTab.classList.add('is-active');
					oldCurrentTab.classList.remove('show');
				}, 200);


				setTimeout(function () {
					newCurrentTab.classList.add('show');
				}, 400)
			}

		}
	});

	tabsPrev.addEventListener('click',function(){
		for (let i = 0; i < tabsLinks.length; i++) {
			if (tabsLinks[i].closest('li').classList.contains('is-active')) {
				console.log(tabsLinks[i]);
				const prevLink = tabsLinks[i - 1];

				const oldCurrentTab = document.getElementById(tabsLinks[i].getAttribute('href'));

				const newCurrentTab = document.getElementById(prevLink.getAttribute('href'));

				tabsLinks[i].closest('li').classList.remove('is-active');

				prevLink.closest('li').classList.add('is-active');

				if (newCurrentTab == null) {
					return;
				}
				const tabs = this.closest('.js-tabs');


				tabs.querySelectorAll('.tab').forEach(tab => {
					setTimeout(function () {
						tab.classList.remove('is-active');
					}, 200)
				});

				setTimeout(function () {
					newCurrentTab.classList.add('is-active');
					oldCurrentTab.classList.remove('show');
				}, 200);


				setTimeout(function () {
					newCurrentTab.classList.add('show');
				}, 400)
			}

		}
	});



	tabsLinks.forEach(link => {
		link.addEventListener('click', function (e) {
			const tabs = this.closest('.js-tabs');
			const href = this.getAttribute('href');
			const currentTab = document.getElementById(href);

			if (currentTab == null) {
				return;
			}

			tabs.querySelectorAll('.tab').forEach(tab => {
				setTimeout(function () {
					tab.classList.remove('is-active');
				}, 200)
			});

			setTimeout(function () {
				currentTab.classList.add('is-active');
				currentTab.classList.remove('show');
			}, 200);

			setTimeout(function () {
				currentTab.classList.add('show');
			}, 400)

			tabs.querySelectorAll('.tabs__nav li').forEach(tabLink => {
				tabLink.classList.remove('is-active')
			});

			this.closest('li').classList.add('is-active');

			e.preventDefault();
		})
	})
};

handleTabs();
